import { lazy, Suspense } from "react";
import {
  Dashboard,
  Appointments,
  Documents,
  TermsOfUse,
  OfficerProfile,
  AccessDenied,
  Resources,
  ResourceDetail,
} from "../_root/pages";
import Login from "../_auth/pages/Login";
// Imported by direct path (not the components barrel) to avoid a module cycle:
// the barrel pulls in Navbar, which imports this file.
import PageContentLoading from "../components/shared/PageContentLoading";
import { strings } from "../resources/strings";

// Lazy so the chat feature (and its markdown/appsync-subscription deps) ships
// as its own chunk instead of on every participant's first paint. Imported by
// path, not via the pages barrel, to keep it out of the eager module graph.
const Chat = lazy(() => import("../_root/pages/Chat"));

export const routes = {
  dashboard: {
    name: strings.pages.dashboard,
    path: "/",
    element: <Dashboard />,
  },
  appointments: {
    name: strings.pages.appointments,
    path: "/appointments",
    element: <Appointments />,
  },
  documents: {
    name: strings.pages.documents,
    path: "/documents",
    element: <Documents />,
  },
  login: {
    name: "Login",
    path: "/login",
    element: <Login />,
  },
  termsOfUse: {
    name: strings.pages.termsOfUse,
    path: "/terms",
    element: (
      <TermsOfUse
        setTermsOfUseAccepted={() => {}}
        shouldDisplayAccept={false}
      />
    ),
  },
  accessDenied: {
    name: strings.accessDenied,
    path: "/access-denied",
    element: <AccessDenied />,
  },
  officerProfile: {
    name: strings.pages.officerProfile,
    path: "/officer",
    element: <OfficerProfile />,
  },
  resources: {
    name: strings.pages.resources,
    path: "/resources",
    element: <Resources />,
  },
  resourceDetail: {
    name: strings.pages.resourceDetail,
    path: "/resources/:id",
    // Generic on purpose: a resource's name ("Detox Center") in the title
    // would stay in a shared device's history and in analytics.
    element: <ResourceDetail />,
  },
  chat: {
    name: strings.chat.navTitle,
    path: "/chat",
    element: (
      <Suspense
        fallback={
          <PageContentLoading loadingText={strings.chat.loadingLabel} />
        }
      >
        <Chat />
      </Suspense>
    ),
  },
};
